import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: ['accountingImputationsViewExtra'],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: "code",
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: ['accountingImputationsViewExtra'],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingImputationsViewExtra'],
        config: {
            headerName: getLocalizedString("positionEditorId"),
            field: "id",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingImputationsViewExtra'],
        config: {
            headerName: getLocalizedString("pollFamily"),
            field: "family",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingImputationsViewExtra'],
        config: {
            headerName: getLocalizedString("clasification"),
            field: "classification",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingImputationsViewExtra'],
        config: {
            headerName: getLocalizedString("availability"),
            field: "availability",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'entryString',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: 'concept',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("conceptName"),
            field: 'conceptString',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("condition"),
            field: 'condition',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("accountCode"),
            field: 'account',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("imputation"),
            field: 'imputationString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("reference"),
            field: 'reference',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("detailedInformation"),
            field: 'detail',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("headerValues"),
            field: 'headerValues',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("valuesForDetail"),
            field: 'detailValues',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.accountingImputations],
        config: {
            headerName: getLocalizedString("distribution"),
            field: 'distributionString',
            filter: "agTextColumnFilter",
        }
    },
]